export const version = '1.1.11-alpha.2'
